// eslint-disable-next-line import/prefer-default-export
export const UserDefinedAlarmEndpoint = {
  LOAD_MANY: '/viiu/user-defined-alarms/load-many',
  SAVE: '/viiu/user-defined-alarms/save',
  DELETE: '/viiu/user-defined-alarms/delete',
  SET_STATUS: '/viiu/user-defined-alarms/set-status',
  LOAD_FIELDS: '/viiu/user-defined-alarms/load-fields',
  LOAD_DEVICES: '/viiu/user-defined-alarms/load-devices',
};
